/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cr_f_minute = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minute`)
};

const es_cr_f_minute = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minuto`)
};

const de_cr_f_minute = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minute`)
};

const nl_cr_f_minute = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minuut`)
};

const fr_cr_f_minute = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minute`)
};

const it_cr_f_minute = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minuto`)
};

const pt_br2_cr_f_minute = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minuto`)
};

const pt_cr_f_minute = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minuto`)
};

const ja_cr_f_minute = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分`)
};

const zh_cr_f_minute = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分钟`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cr_f_minute = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cr_f_minute(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cr_f_minute", locale)
	if (locale === "en") return en_cr_f_minute(inputs)
	if (locale === "es") return es_cr_f_minute(inputs)
	if (locale === "de") return de_cr_f_minute(inputs)
	if (locale === "nl") return nl_cr_f_minute(inputs)
	if (locale === "fr") return fr_cr_f_minute(inputs)
	if (locale === "it") return it_cr_f_minute(inputs)
	if (locale === "pt-BR") return pt_br2_cr_f_minute(inputs)
	if (locale === "pt") return pt_cr_f_minute(inputs)
	if (locale === "ja") return ja_cr_f_minute(inputs)
	return zh_cr_f_minute(inputs)
};